
import React, { Component } from 'react';


class Phone extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }


    render() {
        
        return <React.Fragment>
            <span className="nowrap me-4"><i className="fa-solid fa-phone"></i>&#160;{this.props.value}</span>
        </React.Fragment>
    }
}

export default Phone;